import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Colors } from "../../../utils/colors/colors";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Schema } from "../../../validators/schema/schema";
import { Col, Container, Row } from "react-bootstrap";
import InputComponent from "../../../utils/input/Input";
import ButtonComponent from "../../../utils/button/ButtonComponent";
import styled from "styled-components";
import RadioComponent from "../../../utils/radio-component/RadioComponent";
import {
  ageRangeData,
  eraconnecktEventCountryData,
  internShipTraining,
  employmentStatus,
  genderData,
  experienceDigitalTools,
  digitalLiteracyLevel,
  digitalTraining,
  educationalQualification,
  technicalSkills,
  currentDeviceUsed,
  adoptSkill,
  openForumNigeriaLocation
} from "../../../assets/data/event-rsvp/eventRsvpData";
import SelectComponent from "../../../utils/select-component/SelectComponent";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import { RatingScale } from "../../../utils/scale-range/Handle";
import DragAndDrop from "../../../utils/drag-and-drop/DragAndDrop";
import { useOpenForumRSVP } from "../../../hooks/apis/useOpenForum.api";
import { STORE_KEYS } from "../../../config/store.config";
import { setLocalStorageItem } from "../../../utils/local-storage/localStorage";
import useDate from "../../../hooks/useDate";
import { constants } from "../../../constants/constants";
import { useLocation, useNavigate } from "react-router-dom";
import { useLocationPathName } from "./../../../hooks/useLocationPathname";
import { HOME } from "./../../../routes/index.routes";
import { transformData } from "../../../utils/helpers/convertSelectToArray";





















const RsvpFormModal = ({ closeModal }) => {


  const [data, setData] = useState();
  const [country, setCountry] = useState(eraconnecktEventCountryData[0].value);
  const [selectedEducationalQualification, setSelectedEducationalQualification] = useState(educationalQualification[0].value);
  const [selectedEmploymentStatus, setSelectedEmploymentStatus] = useState(employmentStatus[0].value);
  const [selectedDigitalLiteracyLevel, setSelectedDigitalLiteracyLevel] = useState(digitalLiteracyLevel[0].value);
  const [selectedTechnicalSkills, setSelectedTechnicalSkills] =
    useState(technicalSkills[0].value);
  const [selectedDigitalTraining, setSelectedDigitalTraining] =
    useState(digitalTraining[0].value);
  const [selectedInternShipTraining, setSelectedInternShipTraining] = useState(internShipTraining[0].value);
  const [
    selectedExperienceDigitalTools,
    setSelectedExperienceDigitalTools,
  ] = useState(experienceDigitalTools[0].value);
  const [rateDigitalSkill, setRateDigitalSkill] = useState(1);
  const [fileName, setFileName] = useState("");
  const [resumeFile, setResumeFile] = useState(null);






  const {
    OPEN_FORUM_EVENT_NAME,
  } = constants();
  const { primaryColor } = Colors();
  const { year } = useDate();
  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm({
    resolver: yupResolver(Schema().eventRsvpFormSchema),
    mode: "onBlur",
  });


/**
 * Set the resume file and name from the selected file
 * @param {File[]} file the selected file
 */
  const handleFile = (file) => {
    setResumeFile(file[0]);
    setFileName(file[0]?.name ?? "");
  };



  const {
    mutate,
    status,
    error
  } = useOpenForumRSVP(data, resumeFile);



  const location = useLocation();
  const navigate = useNavigate();

  const { result } = useLocationPathName(location, 1);



  const handleRSVP = useCallback(() => {
    mutate();
  }, [mutate]);


  const onSubmit = useCallback(async (data) => {
    // console.log(data);
    setData({
      ...data,
      country,
      adoptSkill: transformData(data?.adoptSkill),
      "internShipTraining": selectedInternShipTraining,
      "employmentStatus": selectedEmploymentStatus,
      "experienceDigitalTools": selectedExperienceDigitalTools,
      "digitalLiteracyLevel": selectedDigitalLiteracyLevel,
      "digitalTraining": selectedDigitalTraining,
      "educationalQualification": selectedEducationalQualification,
      "technicalSkills": selectedTechnicalSkills,
      rateDigitalSkill,
    });

    // console.log(data);

    // call the function to create hr survey
    handleRSVP();

  },
    [country, handleRSVP, rateDigitalSkill, selectedDigitalLiteracyLevel, selectedDigitalTraining, selectedEducationalQualification, selectedEmploymentStatus, selectedExperienceDigitalTools, selectedInternShipTraining, selectedTechnicalSkills]
  );









  useEffect(() => {

    status === "error" && toast.error(error?.response?.data?.error);
    status === "error" && toast.error(error?.message);
    status === "error" && console.error(error?.message);

    status === "success" &&
      toast.success("Form successfully submitted.") && !result &&
      closeModal();

    status === "success" &&
      toast.success("Form successfully submitted.") && result &&
      navigate(HOME);

    status === "success" && setLocalStorageItem(STORE_KEYS.OPEN_FORUM, OPEN_FORUM_EVENT_NAME)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, result]);









  return (
    <>
      <RsvpHeadingWrapper>
        <HeaderTitle>OpenForum {year}</HeaderTitle>

        <Text>
          Connecting African Youth to Opportunities in the Digital World
        </Text>
      </RsvpHeadingWrapper>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Container
          style={{
            margin: "0",
            padding: "0",
            minWidth: "100%",
            marginTop: "20px",
          }}
        >
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }}>
              <InputComponent
                label={"Full Name"}
                placeholder={"Enter your full name"}
                hasLabel={true}
                name={"name"}
                errorText={errors?.name?.message}
                rest={{ ...register("name") }}
                id={"name"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>

            <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 2 }}>
              <InputComponent
                label={"Email"}
                placeholder={"Enter your email address"}
                hasLabel={true}
                name={"email"}
                errorText={errors?.email?.message}
                rest={{ ...register("email") }}
                id={"email"}
                type={"text"}
                cName={"form-input"}
                style={{
                  width: "100%",
                }}
                control={control}
                defaultValue={""}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"18 and above"}
                label={"Please select your age range"}
                name={"ageRange"}
                id={"ageRange"}
                cName={"form-input p-0"}
                options={ageRangeData}
                hasLabel={true}
                control={control}
                multiSelect={false}
                rest={{ ...register("ageRange") }}
                errorText={errors?.ageRange?.message}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"Select your gender"}
                options={genderData}
                cName={"form-input p-0"}
                hasLabel={true}
                errorText={errors?.gender?.message}
                name={"gender"}
                rest={{ ...register("gender") }}
                multiSelect={false}
                id={"gender"}
                label={"Gender"}
                control={control}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"Select your device"}
                label={"What device do you currently use for work or personal activities?"}
                name={"currentDeviceUsed"}
                id={"currentDeviceUsed"}
                cName={"form-input p-0"}
                options={currentDeviceUsed}
                hasLabel={true}
                control={control}
                multiSelect={false}
                rest={{ ...register("currentDeviceUsed") }}
                errorText={errors?.currentDeviceUsed?.message}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <SelectComponent
                placeholder={"Data Science"}
                label={
                  "Which of these skills would you like to adopt?"
                }
                name={"adoptSkill"}
                id={"adoptSkill"}
                cName={"form-input p-0"}
                options={adoptSkill}
                hasLabel={true}
                control={control}
                multiSelect={true}
                rest={{ ...register("adoptSkill") }}
                errorText={errors?.adoptSkill?.message}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={"Select your venue"}
                label={"Please select your preferred venue"}
                name={"country"}
                id={"country"}
                selectedValue={country}
                cName={"form-input p-0"}
                options={eraconnecktEventCountryData}
                hasLabel={true}
                handleChange={(value) => setCountry(value)}
                control={control}
                multiSelect={false}
                rest={{ ...register("country") }}
                errorText={errors?.country?.message}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"I'm"}
                name={"educationalQualification"}
                id={"educationalQualification"}
                cName={"form-input p-0"}
                options={educationalQualification}
                hasLabel={true}
                control={control}
                rest={{ ...register("educationalQualification") }}
                errorText={errors?.educationalQualification?.message}
                selectedValue={selectedEducationalQualification}
                handleChange={(value) => setSelectedEducationalQualification(value)}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"I'm currently"}
                name={"employmentStatus"}
                id={"employmentStatus"}
                cName={"form-input p-0"}
                options={employmentStatus}
                hasLabel={true}
                control={control}
                rest={{ ...register("employmentStatus") }}
                errorText={errors?.employmentStatus?.message}
                selectedValue={selectedEmploymentStatus}
                handleChange={(value) => setSelectedEmploymentStatus(value)}
              />
            </Col>
          </Row>

          {
            country === openForumNigeriaLocation &&
            <Row
              style={{
                marginBottom: "10px",
              }}>
              <Col>
                <DragAndDrop
                  fileName={fileName}
                  label={"If you would like to participate in the job fair, please attach you resume below"}
                  required={false}
                  name={"cv"}
                  errorText={errors?.cv?.message}
                  rest={{ ...register("cv") }}
                  id={"cv"}
                  handleDragDrop={handleFile}
                  supportiveText={"File must be a PDF file"}
                  multiple={false}
                  control={control}
                />
              </Col>
            </Row>
          }

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"Digital Literacy Level"}
                name={"digitalLiteracyLevel"}
                id={"digitalLiteracyLevel"}
                cName={"form-input p-0"}
                options={digitalLiteracyLevel}
                hasLabel={true}
                control={control}
                rest={{ ...register("digitalLiteracyLevel") }}
                errorText={errors?.digitalLiteracyLevel?.message}
                selectedValue={selectedDigitalLiteracyLevel}
                handleChange={(value) => setSelectedDigitalLiteracyLevel(value)}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"Technical Skill Level"}
                name={"technicalSkills"}
                id={"technicalSkills"}
                cName={"form-input p-0"}
                options={technicalSkills}
                hasLabel={true}
                control={control}
                rest={{ ...register("technicalSkills") }}
                errorText={errors?.technicalSkills?.message}
                selectedValue={selectedTechnicalSkills}
                handleChange={(value) => setSelectedTechnicalSkills(value)}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                placeholder={""}
                label={"Indicate your level of experience with digital tools and technologies"}
                name={"experienceDigitalTools"}
                id={"experienceDigitalTools"}
                cName={"form-input p-0"}
                options={experienceDigitalTools}
                hasLabel={true}
                control={control}
                rest={{ ...register("experienceDigitalTools") }}
                errorText={errors?.experienceDigitalTools?.message}
                handleChange={(value) => setSelectedExperienceDigitalTools(value)}
                selectedValue={selectedExperienceDigitalTools}
              />
            </Col>
          </Row>
          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                options={digitalTraining}
                hasLabel={true}
                errorText={errors?.digitalTraining?.message}
                name={"digitalTraining"}
                rest={{ ...register("digitalTraining") }}
                selectedValue={selectedDigitalTraining}
                placeholder={""}
                label={"Have you ever attended any digital literacy training program?"}
                control={control}
                handleChange={(value) => setSelectedDigitalTraining(value)}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RadioComponent
                options={internShipTraining}
                hasLabel={true}
                errorText={errors?.internShipTraining?.message}
                name={"internShipTraining"}
                rest={{ ...register("internShipTraining") }}
                handleChange={(value) => setSelectedInternShipTraining(value)}
                selectedValue={selectedInternShipTraining}
                placeholder={""}
                label={"Have you ever taken part in an internship?"}
                control={control}
              />
            </Col>
          </Row>

          <Row
            style={{
              marginBottom: "10px",
            }}
          >
            <Col>
              <RatingScale
                min={1}
                max={10}
                value={rateDigitalSkill}
                onChange={setRateDigitalSkill}
                defaultValue={1}
                label={
                  "On a scale of 1 to 10 (<i>1 being not important at all and 10 being absolutely essential</i>), how important do you think digital skills are as a must-have?"
                }
              />
            </Col>
          </Row>
          <BtnWrapper>
            <ButtonComponent
              bgColor={primaryColor}
              text={status === "pending" ? "RSVPing ..." : "RSVP"}
              style={{
                minWidth: "100%",
                margin: "2.125rem auto 1rem auto",
              }}
              click={handleSubmit(onSubmit)}
              isLoading={status === "pending"}
            />
          </BtnWrapper>
        </Container>
      </form>
    </>
  );
};

export default RsvpFormModal;













const RsvpHeadingWrapper = styled.div`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: -3.5rem;
`;

const HeaderTitle = styled.h3`
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 37px;
  color: rgb(235, 129, 69);
`;

const Text = styled.p`
  font-family: "Lato";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
  color: #101010;
  text-align: center;
`;

const BtnWrapper = styled.div`
  margin-top: 40px;
`;
